module.exports = __webpack_public_path__ + "img/face25.4ff34c54.jpg";